import { render, staticRenderFns } from "./ChoiceInspection.vue?vue&type=template&id=3d524b4b&scoped=true&"
import script from "./ChoiceInspection.vue?vue&type=script&lang=ts&"
export * from "./ChoiceInspection.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceInspection.vue?vue&type=style&index=0&id=3d524b4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d524b4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
